import React from "react";

const RadioButtonsMoneyHooks = ({
  register,
  name,
  setVerifyMoney,
  enableMoneyPEN = false,
  setState,
}) => {
  const handle = (e) => {
    const { value } = e.target;
    setVerifyMoney(value);
    setState({
      items: {},
      openTablePdf: false,
      showSimulate: true,
      tableSimulate: [],
      idQuote: "",
      idComponent: null,
    });
  };

  return (
    <div className="wapperRadioButton">
      <div className="wapperRadioButton__dolar">
        <label htmlFor={"dolar_" + name}>
          <input
            type="radio"
            name={name}
            id={"dolar_" + name}
            value="USD"
            ref={register}
            onChange={handle}
            defaultChecked
          />
          <span>Dólares</span>
        </label>
      </div>
      {enableMoneyPEN && (
        <div className="wapperRadioButton__soles">
          <label htmlFor={"soles_" + name}>
            <input
              type="radio"
              name={name}
              id={"soles_" + name}
              value="PEN"
              onChange={handle}
              ref={register}
            />
            <span>Soles</span>
          </label>
        </div>
      )}
    </div>
  );
};

export default RadioButtonsMoneyHooks;
